import Model from '@/models/Model';

export default class Asset extends Model {
    get route () {
        return 'assets';
    }

    static get className () {
        return 'Asset';
    }
}
